import { Link } from "react-router-dom";
import { navItems } from "../constant/data";
import { Button } from "./Button";
import { Link as ScrollLink } from "react-scroll";

interface NavProps {
  hasSet: any;
  navbar: boolean;
  setNavbar: any;
}

export const NavBar = ({ hasSet, navbar, setNavbar }: NavProps) => {
  const setNavValue = () => {
    if (navbar) {
      hasSet(false);
      setNavbar(false);
    } else {
      hasSet(true);
      setNavbar(true);
    }
  };

  return (
    <div>
      <div className="h-[64px] py-10 items-center  bg-[#FAFAFA] w-full  z-[1000] justify-between px-5 sm:px-10 xl:px-20 flex">
        <div className="w-full">
          <Link to={"#"}>
            <img
              src="/images/lockerdash_logo.svg"
              className="w-[104px] h-14"
              alt="logo"
            />
          </Link>
        </div>
        <div className="w-full  bmd:flex hidden">
          <ul className="flex text-[#222] font-onestMedium text-[14px] space-x-10 items-center">
            {navItems?.map((item) => (
              <li className="relative " key={item.id}>
                <ScrollLink
                  className="cursor-pointer"
                  to={item.url}
                  smooth={true}
                  duration={500}
                >
                  <p className="text-textColor font-medium text-[16px] font-onestRegular whitespace-nowrap text-center">
                    {item.item}
                  </p>
                </ScrollLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="w-full justify-end bmd:flex hidden">
          <Button
            title="Use Safe Lockers Now!"
            className="!w-fit !text-white"
            onClick={() =>
              (window.location.href =
                "https://web.fezdelivery.co/ship-now?type=local")
            }
          />
        </div>
        <div className="bmd:hidden font-onestMedium flex w-full justify-end ">
          {!navbar && (
            <div
              className="flex cursor-pointer items-center"
              onClick={() => setNavValue()}
            >
              <div>
                <img
                  src="/images/dots.jpeg"
                  className="h-6 w-12"
                  alt="open-nav-icon"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavBar;
